import PrivacyPolicy from "./privacypolicy/PrivacyPolicy";
import { Navbar, Footer } from "../../components"

export default function Privacy() {
    return (
      <div className='emas__privacy'>
          <Navbar />
          <PrivacyPolicy />
          <Footer />
      </div>
    )
  }